import React from 'react';
import { supabase } from '@/lib/supabase';

export function ManufacturingStartCheckbox({ productId, confirmed, onSaved }) {
  const [busy, setBusy] = React.useState(false);
  const [error, setError] = React.useState('');
  const saving = React.useRef(false);
  const save = async value => {
    if (saving.current) return;
    saving.current = true; setBusy(true); setError('');
    try {
      const result = await supabase.from('mfg_production_order_products')
        .update({ manufacturing_start_confirmed: value }).eq('id', productId)
        .select('manufacturing_start_confirmed').single();
      if (result.error) throw result.error;
      onSaved(result.data.manufacturing_start_confirmed);
    } catch (e) { setError(e.message); }
    finally { saving.current = false; setBusy(false); }
  };
  return <div className="mt-3 max-w-56 text-xs font-normal">
    <label className="flex items-start gap-2"><input type="checkbox" className="mt-0.5 h-4 w-4 shrink-0 accent-green-700" checked={confirmed} disabled={busy} onChange={event => save(event.target.checked)} /><span>Confirmado inicio fabricación</span></label>
    {busy && <p role="status">Guardando…</p>}
    {error && <p role="alert" className="mt-1 text-red-700">No se pudo guardar: {error}</p>}
  </div>;
}
